module.exports = __webpack_public_path__ + "img/7S.cabc48d1.png";